import cn from "classnames"
import { observer } from "mobx-react"
import { WorkTypeLinkSnapshotType } from "modules/orders-manage/models/order"
import {
    OrderContentTasksDictionaryType,
    OrderContentTasksListSnapshotType
} from "modules/orders-manage/models/order-content-tasks"
import { SectionCollapserType } from "modules/orders-manage/models/orders-store"
import React from "react"
import styles from "./Block.module.scss"
import { TTaskFilePath } from "./CategoryBlock"
import { unitStatus } from "./unit-status"
import { UnitStatusMark } from "./UnitStatusMark"


export type TUnit = WorkTypeLinkSnapshotType
type TTask = OrderContentTasksListSnapshotType

class BlockBase extends React.PureComponent<BlockProps> {
    private ref = React.createRef<HTMLDivElement>();

    render() {
        const {
            units,
            store,
            onClick,
            selectedUnitGuid,
            highlightRow
        } = this.props
        return (
            <div ref={this.ref} className={`${styles.block}`}
            >
                {units.length > 0 && (
                    <div className={styles.wrapper}>
                        {units.map((work) => {
                            const contentTask = store.contentTasksList.find(
                                (item) => item.guid === work.unit.guid
                            )
                            const status = unitStatus(contentTask)

                            // const tasksCount = contentTask?.tasks.filter((t) => !t.confirmed).length || 0
                            const isSelected = selectedUnitGuid === work.unit.guid
                            return (
                                <div className={cn(styles.row, {
                                    [styles.selected]: isSelected,
                                    // раздел, открытый по ссылке
                                    [styles.highlighted]: !!highlightRow && highlightRow === work.unit.guid
                                })} key={work.unit.guid} data-object-id={work.unit.guid}
                                    onClick={() => { onClick(work.unit.guid) }}>
                                    <div className={styles.indicator}>
                                        {/* {tasksCount > 0 && (
                                            <span className={styles.countIndicator}>
                                                {tasksCount}
                                            </span>
                                        )} */}
                                        <UnitStatusMark status={status} />
                                    </div>

                                    {/* <div className={styles.orderNumber}>{work.unit.partNumber}</div> */}
                                    <div className={styles.workAndInventory}>{work.unit.name}</div>
                                    <div className={styles.description}>{work.unit.description}</div>
                                    {/* <div className={styles.progress}>
                                        <span
                                            title={work.unit.lastModified ? `Обновлено: ${work.unit.lastModified}` : ""}
                                            className={
                                                work.unit.progress === 0
                                                    ? "percents color-red"
                                                    : work.unit.progress < 50
                                                        ? "percents color-orange"
                                                        : work.unit.progress >= 50 && work.unit.progress < 75
                                                            ? "percents color-blue"
                                                            : work.unit.progress >= 75 && work.unit.progress < 100
                                                                ? "percents color-purple"
                                                                : work.unit.progress === 100
                                                                    ? "percents color-green"
                                                                    : "progress"
                                            }
                                        >
                                            {work.unit.progress} %
                                        </span>
                                    </div> */}
                                </div>
                            )
                        })}
                    </div>
                )}
            </div>
        )
    }


}

export const Block = observer(BlockBase)
export type ActivationDelegate = (unit: TUnit) => void

interface BlockProps {
    category: string
    units: { index: number; unit: TUnit }[]
    onChange: (tasks: TTask[]) => void
    onSort: (from: number, to: number) => void
    touched: boolean
    readOnly: boolean
    store: OrderContentTasksDictionaryType
    baseUrl: string
    orderId: string
    orderName: string
    user: string
    userId: string
    setGuid: (guid: string) => void
    setTaskId: (id: string) => void
    collapserContent: SectionCollapserType
    toggleDeleteShow: () => void
    toggleShowUploadFiles: () => void
    showAddTask: (guid: string) => void
    showDevelopersDialog: (guid: string, fileId: string) => void
    showEditTask: (
        description: string,
        stopDate: string | null,
        file: TTaskFilePath[],
        guid: string,
        employerId: string | null
    ) => void
    highlightRow?: string
    selectedUnitGuid: string | null
    onClick: (guid: string) => void
}


